import React, { useEffect } from "react";
import { connect } from "react-redux";
import * as actionCreators from "../actions/userActivity";
import { bindActionCreators } from "redux";

const TimerProvider = (props) => {
  useEffect(() => {
    if (props.userActivity.timerRunning) {
      let lastUpdateTime = Date.now();
      const interval = setInterval(() => {
        const now = Date.now();
        const deltaTime = now - lastUpdateTime;
        lastUpdateTime = now;
        props.updateTimer(deltaTime);
      }, 1000);
      return () => clearInterval(interval);
    } else {
      return null;
    }
  }, [props.userActivity.timerRunning]);

  return <div>{props.children}</div>;
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators(actionCreators, dispatch);
}

const mapStateToProps = ({ userActivity, ownerApps }, props) => ({
  userActivity,
  ownerApps,
  props,
});

export default connect(mapStateToProps, mapDispatchToProps)(TimerProvider);



// WEBPACK FOOTER //
// ./src/providers/timerProvider.js